import { Filter } from '@anytag/shared-molecules';
import { Template } from './template';
import { useReportFilter } from './hooks';

export const ReportFilter = () => {
  const { filter, setFilterForm, page } = useReportFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="px-4 py-2">
      <Template page={page} />
    </Filter.Provider>
  );
};

export * from './schema-types';
export { useReportFilter };
